import { authFetch } from "../helpers/FetchHelpers";
const { default: DataService } = require("./DataService");

class CreditApprovalDataService extends DataService {
    constructor() {
        super("kredit/approval")
    }

    getList(page, perPage) {
        return authFetch(process.env.REACT_APP_API_URL + '/kredit/onhold', 'POST', JSON.stringify({
            page, perPage
        }))
        .then((data) => {
            console.log('DATA :: ',data.data.Data)
            return {
                creditApprovals: data.data != null && data.data.header?.errorMessage === undefined ? data.data.Data : undefined,
                totalPages: data.data.TotalData < perPage ? 1 : Math.ceil(data.data.TotalData / perPage),
                errorMessage: data.data?.header?.errorMessage,
                needRelogin: data.data?.needRelogin,
            }
        });
    }

    getAprovalList(page, perPage) {
        return authFetch(process.env.REACT_APP_API_URL + '/kredit/approval/list', 'POST', JSON.stringify({
            page, perPage
        }))
        .then((data) => {
            console.log('DATA :: ',data)
            return {
                creditApprovals: data.data != null && data.data.header?.errorMessage === undefined ? data.data.Data : undefined,
                totalPages: data.data.TotalData < perPage ? 1 : Math.ceil(data.data.TotalData / perPage),
                errorMessage: data.data?.header?.errorMessage,
                needRelogin: data.data?.needRelogin,
            }
        });
    }

    approveCredit(kreditId, status) {
        return authFetch(process.env.REACT_APP_API_URL + '/' + this.entity, 'PUT', JSON.stringify({
            ApprovalId: kreditId,
            Status: status,
        })).then((data) => {
            console.log(data)
            return {
                data: data.data != null && data.data.header?.errorMessage === undefined ? data.data : undefined,
                errorMessage: data.data?.errorMessage,
                needRelogin: data.data?.needRelogin,
            }
        });
    }
    
}

export default CreditApprovalDataService;
